import { render, staticRenderFns } from "./PlatformCampaigns.vue?vue&type=template&id=f93261be&"
import script from "./PlatformCampaigns.vue?vue&type=script&lang=js&"
export * from "./PlatformCampaigns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports